import { useReducedMotion } from "framer-motion";

// Tiny "live" animated icon chips — satisfying looping micro-animations.
// variants: pulse | eq | ripple | scan | spin
export const LiveIcon = ({ variant = "pulse", color = "#E9B44C", className = "", testid }) => {
  const reduce = useReducedMotion();
  return (
    <span
      data-testid={testid}
      aria-hidden="true"
      className={`live-icon ${reduce ? "live-icon-static" : ""} ${className}`}
      style={{ "--li": color }}
    >
      {variant === "pulse" && (
        <>
          <i className="li-dot" />
          <i className="li-ring" />
          <i className="li-ring li-ring-2" />
        </>
      )}
      {variant === "eq" && (
        <span className="li-eq">
          <i />
          <i />
          <i />
        </span>
      )}
      {variant === "ripple" && (
        <>
          <i className="li-ring" />
          <i className="li-ring li-ring-2" />
          <i className="li-ring li-ring-3" />
        </>
      )}
      {variant === "scan" && <i className="li-scan" />}
      {variant === "spin" && <i className="li-spin" />}
    </span>
  );
};
